import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { autoRetryViewOf, type WorkflowFourAutoRetry } from './workflowFourPhaseSUtils';

interface Props { chain: { state?: string; segment?: number; autoRetry?: WorkflowFourAutoRetry | null } | null | undefined; /** Chỉ để test: giờ cố định. */ nowMs?: number }

/** Phase S — banner «Máy đang tự thử lại (lần n/3, sau x giây)». Đếm ngược mỗi giây từ `autoRetry.at` (giờ máy), không từ bộ đếm của BE. */
export const FourAutoRetryBanner: React.FC<Props> = ({ chain, nowMs }) => {
  const [now, setNow] = useState(() => nowMs ?? Date.now());
  const scheduled = !!chain?.autoRetry && chain.state === 'FAILED';
  useEffect(() => {
    if (nowMs !== undefined || !scheduled) return undefined;
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [scheduled, nowMs, chain?.autoRetry?.at, chain?.autoRetry?.round]);
  const view = autoRetryViewOf(chain, nowMs ?? now);
  if (!view) return null;
  return <Alert className="wf4-banner" data-testid="auto-retry-banner" type={view.kind === 'exhausted' ? 'warning' : 'info'} showIcon
    icon={view.kind === 'exhausted' ? undefined : <span className="wf4-spin" />} message={view.title} description={view.description} />;
};
